module.exports = __webpack_public_path__ + "static/media/noImage.628298bf.png";